import React from "react";
import { CheckSquare, Clock, AlertTriangle, AlertCircle, RefreshCw, User } from "lucide-react";
import { ChatAvatar } from "./ChatAvatar";
import { useWhatsAppTask } from "../../../../client/hooks/useWhatsAppData";

export default function WhatsTaskDetail({ taskId }) {
  const { data: task, isLoading, isError } = useWhatsAppTask(taskId);

  if (isLoading) {
    return <div style={{ padding: "20px", color: "#666", textAlign: "center" }}>Cargando tarea...</div>;
  }

  if (isError || !task) {
    return <div style={{ padding: "20px", color: "#ef4444", textAlign: "center" }}>Error al cargar la tarea.</div>;
  }

  const createdDate = new Date(task.created_at);
  const now = new Date();
  const diffTime = Math.abs(now - createdDate);
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  let statusText = "Pendiente";
  let statusColor = "#6b7280";
  let statusBg = "#f3f4f6";

  if (task.checked || task.stage === "done") {
    statusText = "Terminada";
    statusColor = "#16a34a";
    statusBg = "#dcfce7";
  } else if (task.stage === "review") {
    statusText = "En revisión";
    statusColor = "#ca8a04";
    statusBg = "#fef9c3";
  } else if (task.stage === "blocked") {
    statusText = "Bloqueada";
    statusColor = "#dc2626";
    statusBg = "#fee2e2";
  } else if (task.stage === "doing") {
    statusText = "En progreso";
    statusColor = "#0284c7";
    statusBg = "#e0f2fe";
  }

  return (
    <div style={{ padding: "var(--space-5)", display: "flex", flexDirection: "column", gap: "var(--space-4)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <h2 style={{ margin: 0, fontSize: "20px", color: "#111", fontWeight: "600", lineHeight: "1.3" }}>
          {task.title}
        </h2>
        <span style={{ backgroundColor: statusBg, color: statusColor, padding: "4px 8px", borderRadius: "12px", fontSize: "12px", fontWeight: "600", whiteSpace: "nowrap" }}>
          {statusText}
        </span>
      </div>

      <div style={{ fontSize: "14px", color: "#555", lineHeight: "1.5" }}>
        {task.description ? (
          <div dangerouslySetInnerHTML={{ __html: task.description }} />
        ) : (
          <span style={{ fontStyle: "italic", color: "#999" }}>Sin descripción</span>
        )}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "var(--space-2)", padding: "12px", backgroundColor: "#f9fafb", borderRadius: "8px", border: "1px solid #eee" }}>
        <div style={{ width: "40px", height: "40px", borderRadius: "50%", backgroundColor: "#e5e7eb", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
          <User size={20} color="#9ca3af" />
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span style={{ fontSize: "12px", color: "#6b7280" }}>Responsable</span>
          <span style={{ fontSize: "14px", fontWeight: "600", color: "#111" }}>{task.assignee || "Sin asignar"}</span>
        </div>
      </div>
      
      {task.supervisor && (
         <div style={{ display: "flex", alignItems: "center", gap: "12px", padding: "12px", backgroundColor: "#f9fafb", borderRadius: "8px", border: "1px solid #eee" }}>
          <div style={{ width: "40px", height: "40px", borderRadius: "50%", backgroundColor: "#e5e7eb", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
            <User size={20} color="#9ca3af" />
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ fontSize: "12px", color: "#6b7280" }}>Revisor (Checker)</span>
            <span style={{ fontSize: "14px", fontWeight: "600", color: "#111" }}>{task.supervisor}</span>
          </div>
        </div>
      )}

      <div style={{ marginTop: "var(--space-2)", display: "flex", alignItems: "center", gap: "6px", color: "#6b7280", fontSize: "13px" }}>
        <Clock size={16} />
        <span>
          Creada hace {diffDays} {diffDays === 1 ? "día" : "días"} ({createdDate.toLocaleDateString()})
        </span>
      </div>
    </div>
  );
}
